export const CanvasSize = { width: 90, height: 54 }
export const DefaultDPI = 96
export const DefaultRatio = 25.4
export const DefaultVersion = '5.3.0'
export const PageSize = 20